/**
 * Shared style factories for XGrid renderCell with makeRenderCell
 * These provide consistent color theming for currency columns
 */
import { lighten } from "@material-ui/core/styles";
import type { Theme } from "src/theme";

// Common color palette helper
export const getColorPalette = (theme: Theme) => {
  const isDark = theme.palette.type === "dark";
  return {
    default: isDark ? theme.palette.common.white : theme.palette.common.black,
    success: isDark ? lighten(theme.palette.success.main, 0.2) : theme.palette.success.main,
    error: theme.palette.error.main,
  };
};

// Style for sales documents (positive values are good/green)
export const makeSalesStyle = (theme: Theme) => {
  const colors = getColorPalette(theme);
  return {
    color: ({ value }: { value: number }) => (value > 0 ? colors.success : colors.default),
  };
};

// Style for transactions documents (negative values are good/green - they reduce costs)
export const makeTransactionsStyle = (theme: Theme) => {
  const colors = getColorPalette(theme);
  return {
    color: ({ value }: { value: number }) => (value < 0 ? colors.success : colors.default),
  };
};

// Style for profit (positive = green, negative = red)
export const makeProfitStyle = (theme: Theme) => {
  const colors = getColorPalette(theme);
  return {
    color: ({ value }: { value: number }) =>
      value > 0 ? colors.success : value < 0 ? colors.error : colors.default,
  };
};
